export const API_URL = process.env.REACT_APP_API_URL;
export const SITE_KEY = process.env.REACT_APP_SITE_KEY;
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
